<div class="taskforce u-default-box-shadow">
	<div class="d-flex justify-content-center p-4">
		<img src="assets/img/logo.svg" alt="">
	</div>
	<div class="p-5">
		<h3 class="head head3 mb-2">Oeps...</h3>
		<ng-content select="[body]"></ng-content>
	</div>
	<div class="p-5">
		<button class="btn u-full-width" (click)="retry()">Terug</button>
	</div>
</div>